import React, { FC, useEffect, useState } from 'react'

interface Props {
  images: string[]
}

const Carousel: FC<Props> = (props) => {
  const {
    images,
  } = props

  const [currentIndex, setCurrentIndex] = useState<number>(0)

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0
    const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1
    setCurrentIndex(newIndex)
  }

  const nextSlide = () => {
    const isLastSlide = currentIndex === images.length - 1
    const newIndex = isLastSlide ? 0 : currentIndex + 1
    setCurrentIndex(newIndex)
  }

  const goToSlide = (slideIndex: number) => {
    setCurrentIndex(slideIndex)
  }

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide()
    }, 3000)

    return () => clearInterval(timer)
  }, [currentIndex])

  return (
    <div
      style={{
        position: 'relative',
        maxWidth: '600px',
        margin: '0 auto',
        borderRadius: '8px',
      }}
    >
      <div
        style={{
          width: '100%',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            transition: 'transform 0.5s ease-in-out',
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {images.map((url, i) => (
            <div
              key={`index_${i + 0}`}
              style={{
                minWidth: '100%',
                boxSizing: 'border-box',
              }}
            >
              <img
                src={url}
                alt={`Slide ${i + 1}`}
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        style={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.4)',
          color: '#fff',
          fontSize: '24px',
          cursor: 'pointer',
          borderRadius: '50%',
          userSelect: 'none',
          left: '-60px',
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
        }}
        onClick={prevSlide}
      >
        ❮
      </button>
      <button
        type="button"
        style={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.4)',
          color: '#fff',
          fontSize: '24px',
          cursor: 'pointer',
          borderRadius: '50%',
          userSelect: 'none',
          right: '-60px',
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
        }}
        onClick={nextSlide}
      >
        ❯
      </button>

      <div
        style={{
          position: 'absolute',
          bottom: '-35px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '8px',
        }}
      >
        {images.map((_, i) => (
          <span
            key={`dot_${i + 0}`}
            onClick={() => goToSlide(i)}
            style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
              backgroundColor: currentIndex === i ? '#4472BA' : '#CCCCCC',
            }}
            role="none"
          />
        ))}
      </div>
    </div>
  )
}

export default Carousel
